export default __webpack_public_path__ + "static/media/houseBB2.e432b11b.svg";